// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#bfcbd9","menuActiveText":"#007DC5","subMenuActiveText":"#f4f4f5","menuBg":"#304156","menuHover":"#263445","subMenuBg":"#1f2d3d","subMenuHover":"#001528","sideBarWidth":"300px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 11